import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AccordionModule } from 'primeng/accordion';
import { SliderModule } from 'primeng/slider';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { PopoverModule } from 'primeng/popover';
import { MenuModule } from 'primeng/menu';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';

import {
  AttachmentDatePipe,
  ChatDatePipe,
  LinkyPipe,
  MinuteSecondsPipe,
  TruncatePipe,
  UnreadMessageDatePipe,
  SlugifyPipe
} from './classes/chat-pipes';
import { AttachmentIconsComponent } from './components/attachment-icons/attachment-icons.component';
import { ChatInfoComponent } from './components/chat-info/chat-info.component';
import { ChatItemComponent } from './components/chat-item/chat-item.component';
import { ChatSuggestionItemComponent } from './components/chat-suggestion-item/chat-suggestion-item.component';
import { ChatSuggestionComponent } from './components/chat-suggestion/chat-suggestion.component';
import { ChatComponent } from './components/chat/chat.component';
import { AdaptiveCardRendererComponent } from './components/content-renderers/adaptive-card-renderer/adaptive-card-renderer.component';
import { EmojiPickerComponent } from '../lib/components/emoji-picker/emoji-picker.component';
import { MentionComponent } from './components/mention/mention.component';
import { SuppressEventsDirective } from './directives/suppress-events.directive';
import { FileSizePipe } from './pipes/file-size.pipe';
import { VideoPlayerComponent } from './components/content-renderers/video-player/video-player.component';
import { VideoCardComponent } from './components/cards/video-card/video-card.component';
import { ChatConfirmationDialogComponent } from './components/chat-confirmation-dialog/chat-confirmation-dialog.component';
import { AudioCardComponent } from './components/cards/audio-card/audio-card.component';
import { ActionCardComponent } from './components/cards/action-card/action-card.component';
import { CallCardComponent } from './components/cards/call-card/call-card.component';
import { SystemMessageCardComponent } from './components/cards/system-message-card/system-message-card.component';
import { AttachmentCardComponent } from './components/cards/attachment-card/attachment-card.component';
import { AttachMenuComponent } from './components/attach-menu/attach-menu.component';
import { CloudFileCardComponent } from './components/cards/cloud-file-card/cloud-file-card.component';
import { LocationCardComponent } from './components/cards/location-card/location-card.component';
import { QuotedMessageCardComponent } from './components/cards/quoted-message-card/quoted-message-card.component';
import { AiSourcesCardComponent } from './components/cards/ai-sources-card/ai-sources-card.component';
import { AiThinkingCardComponent } from './components/cards/ai-thinking-card/ai-thinking-card.component';
import { AiStatsRowComponent } from './components/cards/ai-stats-row/ai-stats-row.component';
import { AiQuickRepliesComponent } from './components/cards/ai-quick-replies/ai-quick-replies.component';
import { DebounceClickDirective } from './directives/debounce-click.directive';
import { MessageInfoComponent } from './components/message-info/message-info.component';
import { EmojiPipe } from './pipes/emoji.pipe';
import { ChatAssetUrlPipe } from './pipes/chat-asset-url.pipe';
import { MarkdownPipe } from './pipes/markdown.pipe';
import { HeaderComponent } from './components/header/header.component';
import {
  ActionIconComponent,
  AvatarComponent,
  HashPipe,
  InitialsPipe,
  MiMenuComponent,
  RoundButtonComponent
} from '@mitel-internal/primeng-lib';
import { DialogService } from 'primeng/dynamicdialog';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    GoogleMapsModule,
    AccordionModule,
    SliderModule,
    TranslateModule,
    ProgressSpinnerModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    PopoverModule,
    MenuModule,
    DialogModule,
    DynamicDialogModule,
    IconFieldModule,
    InputIconModule,
    DragDropModule,
    ScrollingModule,
    ActionIconComponent,
    AvatarComponent,
    RoundButtonComponent,
    HashPipe,
    InitialsPipe,
    MiMenuComponent
  ],
  declarations: [
    ChatComponent,
    ChatItemComponent,
    ChatSuggestionComponent,
    ChatSuggestionItemComponent,
    UnreadMessageDatePipe,
    AttachmentDatePipe,
    EmojiPickerComponent,
    ChatDatePipe,
    LinkyPipe,
    TruncatePipe,
    MentionComponent,
    MinuteSecondsPipe,
    ChatInfoComponent,
    AttachmentIconsComponent,
    FileSizePipe,
    SuppressEventsDirective,
    AdaptiveCardRendererComponent,
    VideoPlayerComponent,
    VideoCardComponent,
    ChatConfirmationDialogComponent,
    AudioCardComponent,
    ActionCardComponent,
    CallCardComponent,
    SystemMessageCardComponent,
    AttachmentCardComponent,
    AttachMenuComponent,
    CloudFileCardComponent,
    LocationCardComponent,
    QuotedMessageCardComponent,
    AiSourcesCardComponent,
    AiThinkingCardComponent,
    AiStatsRowComponent,
    AiQuickRepliesComponent,
    SlugifyPipe,
    DebounceClickDirective,
    MessageInfoComponent,
    EmojiPipe,
    HeaderComponent,
    ChatAssetUrlPipe,
    MarkdownPipe
  ],
  providers: [UnreadMessageDatePipe, ChatDatePipe, AttachmentDatePipe, DialogService],
  exports: [ChatComponent, ChatSuggestionComponent, ChatInfoComponent, AttachmentIconsComponent]
})
export class CloudlinkComponentsChatModule {
  constructor() {}
}
